export default __webpack_public_path__ + "static/media/Groupe9259.0be9dbb8.png";